import type { CaseContext, CaseFilters, Run } from "./types";

export const CASE_PROVIDERS = [
  { value: "v63_reference_test_run", label: "V63 Reference" },
  { value: "yumemi", label: "Yumemi" },
  { value: "vuilabs", label: "VUILabs" },
];
export const REVIEW_STATUS: Record<string, string> = { Pending: "待听审", Reviewing: "听审中", Confirmed: "已确认", False_Positive: "已排除", Needs_Recheck: "待复核" };
export const BAD_CASE_STATUS: Record<string, string> = { Confirmed: "已确认", Triaged: "已归因", Fix_Candidate: "待回归", Regression_Passed: "回归通过", Regression_Failed: "回归失败", Closed: "已关闭" };

export function providerLabel(value?: string | null): string {
  return CASE_PROVIDERS.find((item) => item.value === value)?.label ?? value ?? "未记录";
}
export function providerForRun(run: Run): string {
  if (run.run_type === "reference_boundary") return "v63_reference_test_run";
  const value = String(run.config.provider || run.run_type || "unknown");
  return value === "yumemi_tts" ? "yumemi" : value === "vuilabs_tts" ? "vuilabs" : value;
}
export function modelVersionHint(context?: CaseContext): string {
  return context?.model_version_kind === "checkpoint" ? "Checkpoint" : context?.model_version_kind === "deployment" ? "部署版本（未记录 Checkpoint）" : context?.model_version ? "模型版本" : "版本未记录";
}
export function caseDate(value?: string | null): string {
  if (!value) return "未记录";
  const date = new Date(/(?:Z|[+-]\d\d:\d\d)$/.test(value) ? value : value + "Z");
  return Number.isNaN(date.valueOf()) ? "未记录" : date.toLocaleString("zh-CN", { timeZone: "Asia/Shanghai", hour12: false });
}
export function caseQuery(filters: CaseFilters = {}, page?: { offset?: number; limit?: number }): URLSearchParams {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) if (value) query.set(key, value);
  if (page?.offset != null) query.set("offset", String(page.offset));
  if (page?.limit != null) query.set("limit", String(page.limit));
  return query;
}

export function regressionContext(definition: Record<string, unknown>): CaseContext {
  const record = (value: unknown): Record<string, unknown> => value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const text = (value: unknown) => typeof value === "string" && value ? value : null;
  if (definition.case_context) return record(definition.case_context) as CaseContext;
  // Historical manifests remain immutable; only use their own frozen fields.
  const run = record(definition.source_run);
  const task = record(record(definition.source_task).definition);
  const remote = record(task.remote_case);
  const checkpoint = text(task.checkpoint_id) || text(remote.checkpoint_id);
  const provider = run.run_type === "reference_boundary" ? "v63_reference_test_run" : text(run.provider) || text(run.run_type);
  return {
    provider: provider === "yumemi_tts" ? "yumemi" : provider === "vuilabs_tts" ? "vuilabs" : provider,
    model_version: checkpoint || text(task.model_version),
    model_version_kind: checkpoint ? "checkpoint" : text(task.model_version) ? "model_version" : null,
    voice_id: text(task.physical_voice_id) || text(task.voice_id) || text(remote.physical_voice_id),
    reference_id: text(task.reference_id) || text(remote.reference_id),
    confirmed_at: text(definition.bad_case_created_at),
    discovered_at: null,
  };
}
